<div class="lv-kundensuche-kundennummer" *ngIf="!!uiArtefakt.WertEingabe && uiArtefakt.WertEingabe > 100">
  Kundennummer: {{uiArtefakt.WertEingabe}}</div>
<div class="lv-artefact-container lv-component">
  <button mat-raised-button color="primary" *ngIf="kundensucheEnabled()" (click)="search()">
    Kundensuche
  </button>
  <div *ngIf="(refIdentTouchedOrDirty$ | async) === refIdent">
    <lv-meldung-box [meldungen]="uiArtefakt.UIMeldung"></lv-meldung-box>
  </div>
</div>
